export const readCSVHeader = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const content = event.target.result;
            const firstLine = content.split('\n')[0];
            const headers = firstLine.split(',').map(header => header.trim());
            resolve(headers);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
    });
};
